<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="600"
    v-model="dialog"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        height="48"
        color="accent"
      >
        <v-icon color="black">{{ mdiEmoticonHappyOutline }}</v-icon>
      </v-btn>
    </template>
    <template v-slot:default="">
      <v-card>
        <v-toolbar
          color="primary"
          dark
        >Did you find this useful or not?</v-toolbar>
        <v-card-text>
          <v-textarea
            label="Let us know what you think"
            textarea
            v-model="message"
          ></v-textarea>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            color="success"
            @click="send"
            :loading="isLoading"
          >Send</v-btn>
        </v-card-actions>
        <v-card-text>
          <v-img v-if="screenshot" :src="screenshot" />
          <v-btn v-else @click="saveScreenShot" :loading="isLoadingScreenshot">
            Add Screenshot
          </v-btn>
        </v-card-text>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { mdiEmoticonHappyOutline } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

const html2canvas = () => import(/* webpackChunkName: "route-html2canvas" */'html2canvas');

export default {
  name: 'FeedbackDialog',
  mixins: [loading],
  data() {
    return {
      dialog: false,
      isLoadingScreenshot: false,
      message: '',
      screenshot: undefined,
      mdiEmoticonHappyOutline,
    };
  },
  methods: {
    open() {
      setTimeout(async () => {
        await this.saveScreenShot();
        this.dialog = true;
      }, 800);
    },
    async saveScreenShot() {
      try {
        this.isLoadingScreenshot = true;
        const screenshotTarget = document.body;
        const canvas = await html2canvas(screenshotTarget);
        const base64image = canvas.toDataURL('image/png');
        this.screenshot = base64image;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoadingScreenshot = false;
      }
    },
    async send() {
      try {
        this.isLoading = true;
        const { message, screenshot } = this;
        await this.$http.post('odata/feedbackItems', {
          message,
          screenshot,
        });
        this.dialog = false;
        this.$root.$emit('toast:notify', 'Thank you for your feedback');
        this.message = '';
        this.screenshot = '';
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
